export default __webpack_public_path__ + "static/media/54t.eab1e07a.jpg";